<template>
    <v-app>    
        <v-main>
            <v-container class="fill-height container-background" fluid></v-container>
            <v-container 
                class="fill-height justify-center" 
                fluid
            >
                <v-row 
                    align="center" 
                    justify="center" 
                    style="z-index:10"
                    class="my-auto"
                >
                    <v-col cols="12">
                        <v-expand-transition>
                            <v-card 
                                width="400"
                                v-show="expand"
                                class="elevation-12 mx-auto pa-4"
                            >                            
                                <v-row
                                    justify="center"
                                >
                                    <v-img
                                        src="../../assets/logo.png"
                                        max-width="90"
                                        contain
                                        class="d-flex"
                                    ></v-img>
                                </v-row>
                                <v-row no-gutters> 
                                    <v-col cols="12">
                                        <div class="pa-4">
                                            <v-alert                                                    
                                                type="error"
                                                outlined                                                    
                                                v-if="getloginErrors"
                                                class="red--text"
                                            >
                                                {{ getloginErrors }}
                                            </v-alert>    
                                        </div>                                       
                                        
                                        <div class="text-center font-weight-light primary--text">Welcome to</div>
                                        <div class="text-h4 text-sm-h5 font-weight-black text-center primary--text">{{ schoolName }}</div>        
                                        <v-card-text>
                                            <div class="primary--text text-h5 text-center">Student E-Report Sign in</div>                                            
                                        </v-card-text>

                                        <v-form 
                                            class="pa-5"
                                            @submit.prevent
                                        >
                                            <v-text-field
                                                label="Student ID"                                                
                                                name="id"                                                
                                                type="text"
                                                color="primary"
                                                v-model="formData.student_id"
                                                clearable
                                                autofocus
                                                v-on:keyup="keyPressId"                                                         
                                            >
                                                <v-icon
                                                    slot="prepend"
                                                    color="primary"
                                                >
                                                    mdi-account
                                                </v-icon>
                                            </v-text-field> 

                                            <v-text-field                                               
                                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                :type="show ? 'text' : 'password'"
                                                :label="passwordLabel"
                                                persistent-hint
                                                @click:append="show = !show"                                                    
                                                name="password"
                                                v-model="formData.password"
                                                v-on:keyup="keyPressPassword"
                                                clearable
                                                ref="password"                                                        
                                            >
                                                <v-icon
                                                    slot="prepend"
                                                    color="primary"
                                                >
                                                    mdi-key
                                                </v-icon>
                                            </v-text-field>
                                        
                                    
                                            <div class="text-right mt-6">                                                
                                                <v-btn 
                                                    color="primary" 
                                                    @click="submit" 
                                                    dark
                                                    block
                                                >LOGIN</v-btn>
                                            </div>                                               
                                
                                            
                                        </v-form>

                                        <v-card-actions>
                                            <div>
                                                <v-btn
                                                    v-if="studentIdQuery"
                                                    text
                                                    color="indigo darken-4"
                                                    class="text-caption mt-5"
                                                    @click="openDialog(true)"
                                                >
                                                    Click here to get your student ID
                                                </v-btn>
                                            </div>    
                                        </v-card-actions>
                                  
                                    </v-col>                                
                                </v-row>
                            </v-card>
                        </v-expand-transition>
                    </v-col>
                </v-row>

                <v-overlay
                    :value="overlay"
                    opacity="0.8"
                    z-index="10"                    
                >
                    
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>                   
                </v-overlay>
                <query-id/>
            </v-container>            
        </v-main>
        
    </v-app>
</template>

<script>
import QueryId from '../QueryId'
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    name: 'Login',
    components: {
        QueryId,
    },
    data(){
        return {            
            show: false,
            userpassword: '',
            formData: {
                student_id: '',
                password: '',               
            },           
            studentIdQuery: false,           
            passwordLabel: 'Birth Certificate Pin',
            expand: true, 
        }
    },         
    props: {
        source: String,
    },
    watch: {
        userpassword: {
            handler(val){
                this.formData.student_id = val;                
            }
        },              
    },
    computed: {
        ...mapGetters({
            overlay: 'auth/getOverlay',
            schoolName: 'auth/getSchoolName',            
            getloginErrors: 'auth/getLoginErrors',
            getAuthenticated: 'auth/getAuthenticated',            
            validStudentID: 'auth/getStudentIDValidation',            
        }),       
        
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn', 
            user: 'auth/user',
        }),

        ...mapMutations({
            openDialog: 'auth/setDialog',            
            setUserId: 'auth/setUserId',
            setOverlay: 'auth/setOverlay',
        }),        

        async submitStudentID(){            
            this.setUserId(this.formData.student_id);            
            await this.user();                      
            
        },

        async submit () {
            await this.signIn(this.formData);
            console.log()
            if(this.getAuthenticated){
                this.$router.replace('/term-report');
                this.setOverlay(false);
            }
            else{
                this.loginErrors = this.getLoginErrors 
            }                                               
        },
        
        keyPressId (e) {
            if(e.keyCode === 13){
                this.$refs.password.focus();
                this.submitStudentID();
            }
        },

        keyPressPassword (e) {            
            if(e.keyCode === 13){
                this.submit();
            }
        },
        
    }
}
</script>

<style scoped>
    .container-background{
        /* background-image: url('../../assets/background.jpg'); */
        background-position: center center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        filter: brightness(40%);
        position: absolute;
    }    
</style>